import { useEffect, useState } from 'react';

interface CountUpProps {
  end: number;
  duration?: number;
  formatter?: (value: number) => string;
  className?: string;
}

export function CountUp({ 
  end, 
  duration = 1000, 
  formatter = (v) => v.toString(),
  className 
}: CountUpProps) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime: number | null = null;
    const startValue = 0;
    
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      // Easing function - easeOutExpo
      const easedProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      
      const currentValue = startValue + easedProgress * (end - startValue);
      setCount(currentValue);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    
    requestAnimationFrame(animate);
  }, [end, duration]);

  return <span className={className}>{formatter(count)}</span>;
}
